/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const BrushIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="BrushIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M8.44194 8.44638L13.9419 2.94638L13.0581 2.0625L7.55806 7.5625L8.44194 8.44638Z"
                fill="currentColor"
              />
              <path
                d="M2 13.0005L3.48198 11.5193C3.81365 11.1878 4 10.738 4 10.2691C4 9.29289 4.79138 8.50151 5.76759 8.50151H6C7.10457 8.50151 8 9.39694 8 10.5015V10.7513C8 11.994 6.9925 13.0013 5.74982 13.0011L2 13.0005Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

BrushIcon.tags = [
  'designer',
  'style',
  'paint',
  'art',
  'brush',
  'tool',
  'creative',
  'clean',
  'sweep',
];

BrushIcon.category = 'General Icons';

BrushIcon.iconSize = 16;
